import { render, staticRenderFns } from "./TradeInfoRow.vue?vue&type=template&id=2cf6ebf5&"
import script from "./TradeInfoRow.vue?vue&type=script&lang=js&"
export * from "./TradeInfoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports